import React from "react";
import './PanelOperaciones.scss'
import panel  from "../../../assets/img/paneles/operaciones.png";
import GlobalCard from "../../../components/atoms/GlobalCard/GlobalCard";
const PanelOperaciones = ()=>
{
    return(
        <div className="PanelOperaciones">
            <GlobalCard>
            <img src={panel} alt="" />
            </GlobalCard>
        </div>
    )
}
export default PanelOperaciones